module.exports = __webpack_public_path__ + "img/blog-details.e4e8fb07.jpg";